import * as React from 'react';
import * as FileSaver from 'file-saver';

import { filterNetworks, FilteredNetworksProps } from './filterNetworks';
import NetworksTableComponent from '../../../components/NetworksPage/NetworksTable/NetworksTable';

interface NetworksTableProps extends FilteredNetworksProps {}

class NetworksTable extends React.PureComponent<NetworksTableProps> {
  networksBlob?: Blob;

  render() {
    const { networks, locale } = this.props;

    const getJson = () =>
      JSON.stringify(
        networks.map(network => ({
          [locale.header.network]: network.name,
          [locale.header.asNumber]: network.asNumber,
          [locale.header.peeringPolicy]: locale.policyOptions[network.peeringPolicy],
          [locale.header.routeServers]: network.routeServers
            ? locale.routeServersOptions.true
            : locale.routeServersOptions.false,
        })),
      );

    const getTsv = () => {
      const rowTemplate = (network: string, as: string, policy: string, routeServers: string) =>
        `${network}\t${as}\t${policy}\t${routeServers}\r\n`;

      const preparedNetworks = networks.map(network => ({
        ...network,
        policy: locale.policyOptions[network.peeringPolicy],
        routeServers: network.routeServers
          ? locale.routeServersOptions.true
          : locale.routeServersOptions.false,
      }));

      let tsvString = '';
      tsvString += rowTemplate(
        locale.header.network,
        locale.header.asNumber,
        locale.header.peeringPolicy,
        locale.header.routeServers,
      );
      return preparedNetworks.reduce(
        (accumulator, network) =>
          accumulator +
          rowTemplate(network.name, network.asNumber, network.peeringPolicy, network.routeServers),
        tsvString,
      );
    };

    const saveNetworks = (type: 'json' | 'tsv') => {
      let blobString = '';
      if (type === 'json') {
        blobString = getJson();
      } else if (type === 'tsv') {
        blobString = getTsv();
      }
      blobString = blobString.replace(/<\/?mark>/g, '');

      this.networksBlob = new Blob([blobString], {
        type: 'text/plain;charset=utf-8',
      });
      FileSaver.saveAs(this.networksBlob, `networks.${type}`);
    };

    return (
      <NetworksTableComponent locale={locale} networks={networks} exportNetworks={saveNetworks} />
    );
  }
}

export default filterNetworks(NetworksTable);



// WEBPACK FOOTER //
// /www/client/src/containers/NetworksPage/NetworksTable/NetworksTable.tsx